import { zSchema } from "@zeal/common";

export const getAiConversationsRequestSchema = zSchema.object({
  companyId: zSchema.string().min(1),
  userId: zSchema.string().min(1),
});

export type TGetAiConversationsRequestSchema = zSchema.infer<
  typeof getAiConversationsRequestSchema
>;

export const aiConversationSummarySchema = zSchema.object({
  conversationId: zSchema.string(),
  title: zSchema.string().optional(),
  createdAt: zSchema.string(),
  updatedAt: zSchema.string(),
});

export type TAiConversationSummary = zSchema.infer<
  typeof aiConversationSummarySchema
>;

export const getAiConversationsResponseSchema = zSchema.object({
  companyId: zSchema.string(),
  conversations: zSchema.array(aiConversationSummarySchema),
});

export type TGetAiConversationsResponseSchema = zSchema.infer<
  typeof getAiConversationsResponseSchema
>;
